module.exports = __webpack_public_path__ + "img/1517642238.35e433c1.jpg";